import React from 'react';
import * as firebase from 'firebase/app';
import { connect } from 'react-redux';

import Routes from './routes';
import { firebaseConfig } from './config/constants';
import { setUser } from './features/auth/actions';
import Main from './components/Layout/Main';
import SideBar from './components/SideBar/SideBar';
import Content from './components/Layout/Content';
import Notification from './components/Notification/Notification';

// Add your Firebase credentials in the config object
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const App = ({ setUser, currentUser }) => {
  firebase.auth().onAuthStateChanged(user => {
    setUser(user);
  });

  return (
    <Main>
      <SideBar />
      <Content>
        <Notification />
        <Routes />
      </Content>
    </Main>
  );
};

const mapStateToProps = (state, props) => {
  return {
    currentUser: state.auth.entity
  };
};

export default connect(mapStateToProps, { setUser })(App);
